import { render, staticRenderFns } from "./_otherfeatures.vue?vue&type=template&id=6d984a37"
import script from "./_otherfeatures.vue?vue&type=script&lang=js"
export * from "./_otherfeatures.vue?vue&type=script&lang=js"
import style0 from "./_otherfeatures.vue?vue&type=style&index=0&id=6d984a37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports